import Error from 'next/error';
import { useRouter } from 'next/router';
import { FC, useContext } from 'react';
import Loading from './Loading';
import RentalContext from '@/contexts/rental';
import SchoolContext from '@/contexts/school';
import useRentalFacility from '@/hooks/useRentalFacility';

const AuthRental: FC = ({ children }) => {
  const router = useRouter();

  const { id } = useContext(SchoolContext);
  const [{ rentalFacility: currentRentalFacility }] = useRentalFacility(
    +(router.query.facility_id as string),
    id as number,
  );

  if (
    router.pathname.includes('rental') &&
    !router.pathname.includes('facility-list') &&
    !router.pathname.includes('rental/setting')
  ) {
    if (currentRentalFacility === undefined) {
      return <Loading />;
    }
    if (currentRentalFacility === null) {
      return <Error statusCode={404} title='This page could not be found'></Error>;
    }
  }

  return <RentalContext.Provider value={{ currentRentalFacility }}>{children}</RentalContext.Provider>;
};

export default AuthRental;
